(function (factory) {
    typeof define === 'function' && define.amd ? define(factory) :
    factory();
})((function () { 'use strict';

    /**
     * Listen for successful Pardot form submit via postMessage from iframe, also
     * listen for successful CF7 form submit.
     *
     * This script is only included on pages that use gated-content.
     *
     * @see includes/gated-content.php
     */
    (function(){
        function getDelay() {
            return 'undefined' != typeof carbon.gatedContent.delay ? carbon.gatedContent.delay * 1000 : 5000;
        }
        function getMessage() {
            return 'undefined' != typeof carbon.gatedContent.message ? carbon.gatedContent.message : '';
        }
        // Pardot
        window.addEventListener('message', function(e) {
            // gated token is set
            if (window.location.search.indexOf('gated=') >= 0) return;
            if (!e.origin) return;
            if ('http://go.carbon3d.com' !== e.origin && 'https://go.carbon3d.com' !== e.origin) return;
            var iframeSrc = e.data.formAction;
            if (!iframeSrc) return;
            var iframe = document.querySelector('iframe[src^="'+ iframeSrc +'"]');
            if (!iframe) return;
            var data = {
                action: carbon.gatedContent.ajax_action,
                _ajax_nonce: carbon.gatedContent.ajax_nonce,
                post_id: carbon.currentPostId(),
            };
            var req = new XMLHttpRequest();
            req.open('POST', carbon.gatedContent.ajax_url, true);
            req.onreadystatechange = function() {
                if (req.readyState < 4) return;
                if (200 !== req.status) return;
                var responseData = JSON.parse(req.responseText);
                if ('undefined' == typeof responseData.result.token) return;
                // redirect message
                var div = document.createElement('div');
                div.setAttribute('class', 'gated-content__redirect-message');
                div.innerHTML = getMessage();
                // insert after form container (iframe)
                if (div.innerHTML) iframe.parentNode.insertBefore(div, iframe.nextSibling);
                // redirect with token
                setTimeout(function(){
                    window.location.search = 'view=gated-content&gated=' + responseData.result.token;
                }, getDelay());
            };
            req.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
            req.send(Object.keys(data).map(
                function(k){ return encodeURIComponent(k) + '=' + encodeURIComponent(data[k]) }
            ).join('&'));
        }, false);
        // CF7
        document.addEventListener( 'wpcf7mailsent', function( e ) {
            // gated token is set
            if ('undefined' == typeof e.detail.apiResponse.token) return;
            // redirect message
            var div = document.createElement('div');
            div.setAttribute('class', 'gated-content__redirect-message');
            div.innerHTML = getMessage();
            // insert after form container
            if (div.innerHTML) e.target.parentNode.insertBefore(div, e.target.nextSibling);
            // redirect with token
            setTimeout(function(){
               window.location.search = 'view=gated-content&gated=' + e.detail.apiResponse.token;
            }, getDelay());
        }, false );
    })();

    /**
     * Sample code to be included in Pardot.
     *
        (function(){
            if (window === window.parent) return;
            var formElem = document.getElementById('pardot-form');
            if (!formElem) return;
            if (formElem.querySelector('.errors')) return;
            if (!formElem.querySelector('[id^="focus"')) return;
            // form submitted, page refreshed
            var data = {
                'name': 'pardot-submit',
                'status': 'success',
                'formAction': formElem.getAttribute('action'),
            };
            window.parent.postMessage(data, 'https://www.carbon3d.com');
            window.parent.postMessage(data, 'https://dev-carbon3d.pantheonsite.io');
            window.parent.postMessage(data, 'https://test-carbon3d.pantheonsite.io');
            window.parent.postMessage(data, 'https://dev-gating-carbon3d.pantheonsite.io');
        })();
     *
     */

}));
